"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _core = require("@material-ui/core");
var _reactI18next = require("react-i18next");
var _pageContext = _interopRequireDefault(require("../../context/pageContext"));
var _userContext = _interopRequireDefault(require("../../context/userContext"));
var _appinfo = _interopRequireDefault(require("../appinfo"));
var _loginform = _interopRequireDefault(require("../loginform"));
var _menulist = _interopRequireDefault(require("../menulist"));
var _userInvitePersonQrCode = _interopRequireDefault(require("../user-invite-person-qr-code"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _core.makeStyles)(theme => ({
  root: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    height: "100%",
    padding: theme.spacing(4, 2)
  },
  avatar: {
    fontSize: 14,
    fontWeight: theme.typography.fontWeightBold
  },
  user: {
    background: theme.palette.action.hover,
    borderRadius: theme.shape.borderRadius,
    display: "flex",
    flexWrap: "wrap",
    padding: theme.spacing(2)
  },
  userTextbox: {
    margin: theme.spacing(0, 0, 0, 2)
  },
  buttonLogout: {
    alignSelf: "center",
    margin: theme.spacing(0, 0, 0, "auto"),
    [theme.breakpoints.only("xs")]: {
      flex: "0 0 100%",
      marginTop: theme.spacing(1.5)
    }
  },
  infoBox: {
    background: theme.palette.action.hover,
    borderRadius: theme.shape.borderRadius,
    margin: theme.spacing("auto", 0, 0, 0),
    padding: theme.spacing(2)
  }
}));
const UserMenu = () => {
  const {
    REACT_APP_USERNAV
  } = process.env;
  const [pageData] = (0, _react.useContext)(_pageContext.default);
  const [userData] = (0, _react.useContext)(_userContext.default);
  const {
    menuGroups
  } = pageData.data;
  const css = useStyles();
  const group = (0, _lodash.find)(menuGroups, function (o) {
    return o.title === REACT_APP_USERNAV;
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: css.root
  }, !(0, _lodash.isEmpty)(userData) && userData.state !== 1 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(UserAvatarExt, null), group && /*#__PURE__*/_react.default.createElement(_menulist.default, {
    data: group
  }), /*#__PURE__*/_react.default.createElement(_userInvitePersonQrCode.default, null), /*#__PURE__*/_react.default.createElement(Info, null)) : /*#__PURE__*/_react.default.createElement(Form, null));
};
const UserAvatarExt = () => {
  const {
    REACT_APP_PATH
  } = process.env;
  const [userData] = (0, _react.useContext)(_userContext.default);
  const css = useStyles();
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    firstname,
    lastname,
    media,
    levelTitle,
    roomNumber
  } = userData;
  let chars = "";
  if (firstname) {
    chars = firstname.charAt(0);
  }
  if (lastname) {
    chars += lastname.charAt(0);
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: css.user
  }, /*#__PURE__*/_react.default.createElement(_core.Avatar, {
    className: css.avatar,
    alt: firstname + " " + lastname,
    src: media !== null && media !== void 0 && media.filename ? REACT_APP_PATH + media.filename : ""
  }, chars), /*#__PURE__*/_react.default.createElement("div", {
    className: css.userTextbox
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "subtitle2"
  }, firstname, " ", lastname), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "caption",
    component: "div"
  }, levelTitle), roomNumber && /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "caption",
    component: "div"
  }, t("site.ui.labels.roomNumber"), ": ", /*#__PURE__*/_react.default.createElement("strong", null, roomNumber))), /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: css.buttonLogout,
    onClick: logout,
    color: "primary",
    variant: "outlined",
    size: "small"
  }, t("site.login.labels.logout"))));
};
const Info = () => {
  const {
    REACT_APP_DESCRIPTION,
    REACT_APP_HEADERLOGOMAXWIDTH,
    REACT_APP_LOGOAPPINFO,
    PUBLIC_URL
  } = process.env;
  const [appInfo, setAppInfo] = (0, _react.useState)(false);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const css = useStyles();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: css.infoBox
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    mt: 1,
    mb: 2
  }, /*#__PURE__*/_react.default.createElement("img", {
    style: {
      maxWidth: REACT_APP_HEADERLOGOMAXWIDTH,
      width: "100%",
      display: "block"
    },
    src: PUBLIC_URL + "/img/" + REACT_APP_LOGOAPPINFO,
    alt: ""
  })), /*#__PURE__*/_react.default.createElement(_core.Box, {
    mt: 1,
    mb: 2
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "body2"
  }, REACT_APP_DESCRIPTION)), /*#__PURE__*/_react.default.createElement(_core.Button, {
    fullWidth: true,
    size: "small",
    variant: "contained",
    color: "primary",
    onClick: () => setAppInfo(true)
  }, t("site.appInfo.info"))), /*#__PURE__*/_react.default.createElement(_appinfo.default, {
    open: appInfo,
    setOpen: setAppInfo
  }));
};
const Form = () => {
  return /*#__PURE__*/_react.default.createElement(_loginform.default, null);
};
const logout = () => {
  const {
    REACT_APP_PATH
  } = process.env;
  const headers = {};
  if (localStorage.getItem("logintoken")) {
    headers["Authorization"] = "Bearer " + localStorage.getItem("logintoken");
  }
  const formData = new FormData();
  formData.append("jsonResponse", 1);
  fetch(REACT_APP_PATH + "/logout.internal", {
    method: "POST",
    headers,
    body: formData
  });
  localStorage.removeItem("logintoken");
  window.location.href = "/";
};
var _default = exports.default = UserMenu;